export enum TemperatureFormats {
  Celsius = "Celsius",
  Fahrenheit = "Fahrenheit",
}